/* DashboardComponent.js */

"use strict";
const EventEmitter = require("events").EventEmitter;
const Renderer = require("./DashboardRenderer");

/**
 * A Dashboard namespace.
 * @namespace Dashboard
 */

/**
 * @class DashboardComponent
 * @extends EventEmitter
 *
 * @fires DashboardComponent#Shutdown
 */

class DashboardComponent extends EventEmitter {
    constructor(logger, di, router, controlAppNav, userSession, DeviceEntityDef) {
        super();
        //console.log({ logger, di, router, controlAppNav, userSession }); //IgrEd

        this._logger = logger;
        this._di = di.createDependencyInjector();
        this._router = router;
        this._controlAppNav = controlAppNav;
        this._userSession = userSession;
        this._deviceEntityDef = DeviceEntityDef;

        // this._di.registry.register("App.GameConsole.Section.Dashboard.dashboard_section", this);

        this._registerListeners();
        this._renderer = new Renderer(this);

        window[this.constructor.name] = this; //IgrEd
    }

    get renderer() {
        return this.getRenderer();
    }

    get rootElement() {
        return this._renderer.getRootElement();
    }

    get activeOrgId() {
        return this._userSession.activeOrganization && this._userSession.activeOrganization.id;
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS */
    /*******************************************/

    _triggerShutdown() {
        /**
         * @event DashboardComponent#Shutdown
         * @param {DashboardComponent}
         */
        this.emit("Shutdown", this);
    }

    _registerListeners() {
        this._userSession.on(
            "OrganizationChange",
            (this._onActiveOrganizationChanged = this._onActiveOrganizationChanged.bind(this))
        );
    }

    _unregisterListeners() {
        this._userSession.removeListener("OrganizationChange", this._onActiveOrganizationChanged);
    }

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS */
    /* START PUBLIC COMPONENT MODEL METHODS */
    /*******************************************/

    getRenderer() {
        return this._renderer;
    }

    shutdown() {
        this._triggerShutdown();
        this._unregisterListeners();
        const shutDowns = [this._renderer?.shutdown() || Promise.resolve()];

        this.removeAllListeners();
        return Promise.all(shutDowns).then(
            () => {
                this._renderer = undefined;
            },
            (/*err*/) => {}
        );
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    _onActiveOrganizationChanged({id: activeOrgId /*, name*/} = {}, {id: prevOrgId} = {}) {
        if (activeOrgId === prevOrgId) {
            return;
        }
        //console.log("orgChanged", id); //IgrEd
    }

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE METHODS */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS */
    /* START PUBLIC API METHODS */
    /*******************************************/

    /*******************************************/
    /* END PUBLIC API METHODS */
    /*******************************************/
}

module.exports = DashboardComponent;

module.exports.$inject = [
    "$teve.logger",
    "$teve.di",
    "$teve.router",
    "$teve.controlAppNav",
    "$teve.userSession",
    "$teve.entities.Device",
];
